<template>
    <div class="container">
        <div class="row"><h4>Manage Image and/or Downloadable Files</h4></div>
        <div class="row">
            <div class="col-sm-6">
                <div>
                    <label for="asset_type">Select Asset Type</label>
                        <select style="max-width:50%;margin:auto;"  @change="resetAsset()" class="form-control"  v-model="asset_type">
                            <option value="image">Image</option>
                            <option value="pdf">PDF</option>
                        </select>
                    <label  for="name">Name</label>
                    <input style="max-width:50%;margin:auto;"  id="inputName" class="form-control" v-model="name" type="text" disabled />
                    <label for="description">Description</label>
                    <input style="max-width:50%;margin:auto;"  class="form-control"  v-model="description" type="text"/>
                    <label for="title">Display Title</label>
                    <input style="max-width:50%;margin:auto;"  class="form-control" v-model="title" type="text"/>

                    <input  style="max-width:50%;margin:auto;;margin-top:2px;" @change="updateFileDetails()" class="form-control" type="file" ref="file">
                     <div style="margin:auto;padding:auto;">
                        <button  style="margin-top:4px;" class="button btn btn-sm btn-primary" v-html="saveBtnText()" @click="uploadFile()">Upload File</button>
                        <button style="margin-top:4px;" v-if="selectedPDF||selectedImage" class="button btn btn-sm btn-danger" @click="deleteAssetConfirm()">Delete Selected Asset</button>
                        <button style="margin-top:4px;" v-if="selectedPDF||selectedImage" class="button btn btn-sm btn-warning" @click="resetAsset()">Reset for New Asset</button>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="row">
                    Image List: <p v-if="selectedImage">Selected: {{selectedImage}}</p>
                        <select  style="max-width:180%;margin:auto" class="form-control" @change="selectedPDF='';selasset='';loadAsset('image', selectedImage);asset_type='image';" v-model="selectedImage">
                            <option v-for="image in imageList" :key="image.id" :value="image.id">{{image.name}} ({{image.description}})</option>
                        </select>
                    </div>
                    <div class="row mt-2">
                        PDF list:
                        <select  style="max-width:80%;margin:auto;"  @change="selectedImage='';selasset='';dropImage();loadAsset('pdf', selectedPDF);asset_type='pdf'; " class="form-control" v-model="selectedPDF">
                            <option v-for="pdf in downloadList" :key="pdf.id" :value="pdf.id">{{pdf.display_title}}</option>
                        </select>
                        <p class=" mt-2" v-if="selectedPDF && selasset">Selected: {{selasset.display_title}}
                            <a target="_blank"  :href="'storage/' + this.selasset.file_path" class="button btn btn-sm btn-primary" v-if="selectedPDF" @click="download">Download</a>
                        </p>
                    </div>
                <div style="row margin-top:8px;" id="imageDisplay"></div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import Swal from 'sweetalert2';
import Compressor from 'compressorjs';

export default {
    name:'AssetManagement',
    props:{
        images: {
            type:String,
            default:[]
        },
        downloads: {
            type:String,
            default:[]
        }
    },
    data(){
        return {
            selasset:'',
            asset_type:'',
            asset_id:'',
            name:'--Auto-fill on file selection--',
            description: '',
            title: '',
            file_path: '',
            width:0,
            height:0,
            editmode:false,
            selectedImage:'',
            imageList:[],
            downloadList:[],
            selectedPDF:'',
            asset:'',
        }
    },
    mounted() {
        console.log('Component mounted.');
        this.imgList;
        this.dwnList;
    },
    methods: {
        saveBtnText() {
            let retVal = "Upload File";
            if(this.selasset){
                retVal = "Save File Details";
            }
            return retVal;
        },
        download() {

        },
        resetAsset(){
            this.selasset = '';
            this.asset_id = '';
            this.name = '';
            this.enableInputNameField(true);
            this.description = '';
            this.title = '';
            this.file_path =  '';
            this.selectedImage = this.selectedPDF = '';
            // this.asset_type = '';
            this.dropImage();
        },
        uploadFile() {
            console.error('uploadFile invoked...');
            this.asset = this.$refs.file.files[0];
            // if(this.getFileExtension(this.name)=='jpg') {
            //     this.submitCompressedFile();
            // } else {
            // this.submitFile();
            // }
            this.submitFile();

        },
        updateFileDetails(){
            this.name =  this.$refs.file.files[0].name;
            this.title = this.$refs.file.files[0].name;
            this.enableInputNameField(false);
        },
        enableInputNameField(boolVal){
            document.getElementById('inputName').disabled = boolVal;
        },
        getFileExtension(filename) {
            var a = filename.split(".");
            if( a.length === 1 || ( a[0] === "" && a.length === 2 ) ) {
                return "";
            }
            return a.pop().toLowerCase();
        },

        submitFile() {
            console.error('submitFile invoked...');
            var url = '/edu/assets/create';

            const formData = new FormData();
            //const fs = require ('fs');  fs.createReadStream(file);
            formData.append('file', this.asset);
            formData.append('name', this.name);
            formData.append('description', this.description);
            formData.append('title', this.title);
            formData.append('asset_type', this.asset_type);
            formData.append('owner', 'SYSTEM');//////////////////////////////////// SIGNIFY THAT THE ASSET BELONGS TO THE SYSTEM, NOT ANY MEMBER/USER
            if(this.selasset) formData.append('file_path', this.selasset.file_path);

            // if(this.asset_type=='image') {
            //     formData.append('width', this.width);
            //     formData.append('height', this.height);
            // }
            const csrf =  document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            // console.log("csrf: " + csrf);
            const headers = {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': csrf,
                'Content-Type': 'multipart/form-data',
            };

            if(this.asset_id != null && this.asset_id != '') {
                formData.append('asset_id', this.asset_id);
                url = '/edu/assets/update';
            }
            // const headers = { ['Content-Type': 'multipart/form-data', 'csrf-token':  };
                console.error('posting file...');
                Axios.post(url, formData, {headers })
                .then  ((response) => {
                    this.asset_id = response.data.id;
                    console.error("Saved asset: " + response.data.id)
                    this.updateToast(response.data.message, 5000);
                    this.refreshAssets(response.data.images, 'image');
                    this.refreshAssets(response.data.downloadables, 'pdf');
                }).catch((err)=>{
                    console.error(err.message);
                    this.updateToast(err.message, 5000);
                }).finally(()=> {
                    console.log('creation done');
                    console.log('done saving/updating file...');
                    this.selasset = this.getItemByID(this.asset_type, this.asset_id);
                    if(this.asset_type == 'image') this.displayImage();
                });


            // res.data.files; // binary representation of the file
            // res.status; // HTTP status
        },
            submitCompressedFile() {
            console.error('submitFile invoked...');
            var url = '/edu/assets/create';
           const formData =  this.compress(this.asset);

            new Compressor(this.asset, {
                quality: 0.6,

                // The compression process is asynchronous,
                // which means you have to access the `result` in the `success` hook function.
                success(result) {
                const formData = new FormData();
                // formData.append('file', result, result.name);
                formData.append('file', result);
                formData.append('name', this.name);
                formData.append('description', this.description);
                formData.append('title', this.title);
                formData.append('asset_type', this.asset_type);
                formData.append('owner', 'SYSTEM');//////////////////////////////////// SIGNIFY THAT THE ASSET BELONGS TO THE SYSTEM, NOT ANY MEMBER/USER
                if(this.selasset) formData.append('file_path', this.selasset.file_path);

                // if(this.asset_type=='image') {
                //     formData.append('width', this.width);
                //     formData.append('height', this.height);
                // }
                const csrf =  document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                // console.log("csrf: " + csrf);
                const headers = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': csrf,
                    'Content-Type': 'multipart/form-data',
                };

                if(this.asset_id != null && this.asset_id != '') {
                    formData.append('asset_id', this.asset_id);
                    url = '/edu/assets/update';
                }
// Send the compressed image file to server with XMLHttpRequest.

                console.error('posting file...');
                Axios.post(url, formData, {headers })
                .then  ((response) => {
                    this.asset_id = response.data.id;
                    console.error("Saved asset: " + response.data.id)
                    this.updateToast(response.data.message, 5000);
                    this.refreshAssets(response.data.images, 'image');
                    this.refreshAssets(response.data.downloadables, 'pdf');
                }).catch((err)=>{
                    console.error(err.message);
                    this.updateToast(err.message, 5000);
                }).finally(()=> {
                    console.log('creation done');
                    console.log('done saving/updating file...');
                    this.selasset = this.getItemByID(this.asset_id);
                    if(this.asset_type == 'image') this.displayImage();
                });
            },
            error(err) {
            console.log(err.message);
            },
        });




            // res.data.files; // binary representation of the file
            // res.status; // HTTP status
        },
        deleteAssetConfirm() {
            Swal.fire({
                title: 'Please confirm deletion of the currently selected asset.' + this.sel_asset_id + ' ' + this.asset_type,
                showDenyButton: true,
                // showCancelButton: true,
                confirmButtonText: 'Delete',
                denyButtonText: `Don't delete`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.deleteSelectedAsset();
                    // Swal.fire('Deleted!', '', 'success');
                } else if (result.isDenied) {
                    Swal.fire('Asset was not deleted', '', 'info');
                }
            });
        },
        deleteSelectedAsset() {
            Axios.put('/assets/delete/' +  this.asset_id , {
                asset_type: this.asset_type,
                id: this.asset_id
            })
            .then((response) => {
                this.updateToast(response.data.message, 3000);
                this.imageList = JSON.parse(response.data.images);
                this.downloadList = JSON.parse(response.data.downloadables);
            })
            .catch((error) => {
                console.log(error);
                this.updateToast(error.message, 3000, 'error');
            })
            .finally();
        },
        compress(file) { //From https://github.com/fengyuanchen/compressorjs
            const formData = new FormData();
            new Compressor(file, {
                quality: 0.6,
                // The compression process is asynchronous,
                    // which means you have to access the `result` in the `success` hook function.
                    success(result) {
                    // The third parameter is required for server
                    formData.append('file', result, result.name);
                    return formData;
                },
                error(err){
                    console.log(err.message);
                },
            });
        },



        editAsset(asset_type, id) {
            this.loadAsset(asset_type, id);
        },
        getItemByID(asset_type, id) {
            console.log("need image with id: " + id);
            if(asset_type==='image') {
                return this.imageList.find((image)=> {
                // console.log(image);
                        if(image.id === id) {
                            console.error("Found " + image.title);
                            return image;
                        }
                    });
            }
            if(asset_type==='pdf') {
            return this.downloadList.find((download)=> {
                    if(download.id == id) return download;
                });
            }

        },
        loadAsset(asset_type, id) {
            var item = this.getItemByID(asset_type, id);
            // console.log("Found Item, loading...");
            // console.log(item);
            this.selasset = item;
            this.asset_id =  this.selasset.id;
            this.name =  this.selasset.name;
            this.enableInputNameField(false);
            this.description =  this.selasset.description;
            this.title =  this.selasset.title;
            // if(asset_type=='image') {
            //    this.width =  this.selasset.width;
            //    this.height = this.selasset.height;
            // }
            this.file_path =  this.selasset.file_path;
            if(asset_type ==='image') this.displayImage(id);

        },
        displayImage() {
            // console.error(this.selasset);
            // console.log(this.selasset[0].file_path);
            // const html = `<img src='https://` + window.location.host + '/storage/' + this.selasset.file_path + `'>`;
            if(this.selasset){
                const html = `<img src='/storage/` + this.selasset.file_path + `' width='100%' >`;
                document.getElementById('imageDisplay').innerHTML = html;
            }
        },
        dropImage() {
                document.getElementById('imageDisplay').innerHTML = '';
        },
        refreshAssets(assets, asset_type) {
            if(asset_type==='image') this.imageList = JSON.parse(assets);
            if(asset_type==='pdf') this.downloadList = JSON.parse(assets);
        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                // toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: timer,
                timerProgressBar: true
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
    },
    computed:{
        imgList(){
            if(this.images) this.imageList = JSON.parse(this.images);
            return this.imageList;
        },
        dwnList(){
            if(this.downloadables) this.downloadList = JSON.parse(this.downloadables);
            return this.downloadList;
        }
    }
}

</script>
<style scoped>

</style>
